import { render, staticRenderFns } from "./sp_table.vue?vue&type=template&id=c1158948"
import script from "./sp_table.vue?vue&type=script&lang=js"
export * from "./sp_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports